import { Component, OnInit, TemplateRef, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { BsDatepickerViewMode, BsDatepickerConfig } from 'ngx-bootstrap/datepicker/ngx-bootstrap-datepicker';
import { SWAlertService } from '../../services/swalert.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscriber } from 'rxjs';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { EventEmitter } from 'events';
import * as _ from 'lodash';
import { now } from '@amcharts/amcharts4/.internal/core/utils/Time';
import { string } from '@amcharts/amcharts4/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-payment',
  templateUrl: './admin-payment.component.html',
  styleUrls: ['./admin-payment.component.css']
})
export class AdminPaymentComponent implements OnInit {

  modalRef: BsModalRef;
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private System: TSFuntionService, private router: Router, private SW: SWAlertService, private modalService: BsModalService, public datepipe: DatePipe) { }
  PaymentForm: FormGroup;
  InputFrom: FormGroup;

  iswait: boolean = true;
  iswaitColor: "";
  SumID: string;
  sdete: Date;
  ResultPermission: boolean = true;
  isResult: boolean = false;

  arrCbExport: Array<any> = [];
  arrCbPaid: Array<any> = [];
  arrGL: any;
  arrMulti: any;
  lstData: any;
  isSupDoc: any;
  sSeeNote: any;
  sSearch: string = "";
  sDetailData = "";
  _ArrData = [];
  _ArrDataBind = [];
  Editnum = null;

  public settings = {};
  get _PaymentForm() { return this.PaymentForm.controls; }
  get SupDoc() { return this._PaymentForm.SupDoc as FormArray; }
  FilterGrid = {
    sSearch: "",
    nStatusID: [],
    nReqTypeID: [],
    sCompanyCode: []
  }

  settings_com = {};
  ArrCompany = [];
  async ngOnInit() {
    this.SetForm();
    this.SupDoc.push(new FormGroup({
      cbExport: new FormControl(''),
      nYear: new FormControl(''),
      sPaymentDoc: new FormControl('', Validators.required),
      sSupportDoc: new FormControl('', Validators.required),
      sReqNo: new FormControl(''),
      sVendor: new FormControl(''),
      sCCTR: new FormControl(''),
      nTotalAmount: new FormControl(''),
      dDueDate: new FormControl(''),
      sNote: new FormControl(''),
      IsStatus: new FormControl(''),
      IsReqUrgent: new FormControl(''),
      IsVendorGroup: new FormControl(''),
      cbSubDoc: new FormControl(''),
      Payment_Doc: new FormControl("", Validators.required)
    }))
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    this.ResultPermission = await this.System.CheckPermissionMeun(36);
    if (this.ResultPermission == false) {
      this.isResult = true;
    }
    else {
      this.isResult = false;
    }
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }

    await this.loadStatus();
    this.Search();
  }

  _Status = [];
  _RequestType = [];

  async loadStatus() {
    //Type
    let GetTaskType = await this.http.get<any>(this.System.SiteName + "api/AdminPayment/GetTaskType").toPromise();
    if (GetTaskType) {
      this._RequestType = GetTaskType;
    }
    //Status
    let GetStatus = await this.http.get<any>(this.System.SiteName + "api/AdminPayment/GetStatus").toPromise();
    if (GetStatus) {
      this._Status = GetStatus;
    }
    let GetCompany = await this.http.get<any>(this.System.SiteName + "api/AdminPayment/GetCompany").toPromise();
    if (GetCompany) {
      this.ArrCompany = GetCompany;
    }
  }

  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }

  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";


  @Output() onChange = new EventEmitter();
  Columns = [
    { ColumnName: "Year", SortField: "", Width: "9%" },
    { ColumnName: "Payment / Receive Doc", SortField: "", Width: "10%" },
    { ColumnName: "Req. No.", SortField: "sRequestCode", Width: "9%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "13%" },
    { ColumnName: "Vendor / Customer", SortField: "vendor", Width: "14%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Cost Center", SortField: "sCCTR", Width: "9%" },
    { ColumnName: "Net Total", SortField: "nGrandTotalAmtInvoice", Width: "13%" },
    { ColumnName: "Due Date", SortField: "dDueDate_SSC", Width: "8%" },
    { ColumnName: "Note", SortField: "sDocHeader", Width: "7%" }
  ]

  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }


  BindDataTable() {
    let _this = this;
    this.OptionGrid.nTotalItem = this._ArrData.length;
    let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    let nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];

    if (this.arrCbExport.length > 0) {
      this._ArrData.forEach(function (item) {
        let itemChecked = _this.arrCbExport.filter(m => m.sRequestID == item.sRequestCode);
        if (itemChecked.length > 0) {
          _this._ArrDataBind.push(Object.assign({ cbExport: itemChecked[0].isChecked }, item));
        }
        else {
          _this._ArrDataBind.push(Object.assign({ cbExport: false }, item));
        }
      });
    }
    else {
      if (this.isResult == false) {
        var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
        cbExport_All.checked = false;
      }
      this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    }

    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
    this.System.UnBlockUI();

    this.SupDoc.clear();
    this._PaymentForm.SupDoc.reset();
    let num = 0;
    this._ArrDataBind.forEach(function (datain, i) {
        _this.SupDoc.push(new FormGroup({
          cbExport: new FormControl(''),
          nYear: new FormControl(''),
          sPaymentDoc: new FormControl('', Validators.required),
          sSupportDoc: new FormControl('', Validators.required),
          sReqNo: new FormControl(''),
          sReqType: new FormControl(''),
          sVendor: new FormControl(''),
          sCCTR: new FormControl(''),
          nTotalAmount: new FormControl(''),
          dDueDate: new FormControl(''),
          sNote: new FormControl(''),
          IsStatus: new FormControl(''),
          IsReqUrgent: new FormControl(''),
          IsVendorGroup: new FormControl(''),
          cbSubDoc: new FormControl('')
        }))
        _this.SupDoc.at(num).patchValue({
          cbExport: datain.cbExport,
          nYear: datain.nYear == null ? new Date().getFullYear() : datain.nYear,
          sPaymentDoc: datain.sPaymentDoc,
          sSupportDoc: datain.sSupportingDocument,
          sReqNo: datain.sRequestCode,
          sReqType: datain.sReqType,
          IsReqType: datain.nReqTypeID,
          sVendor: datain.vendor,
          sCCTR: datain.sCCTR,
          nTotalAmount: datain.nGrandTotalAmtInvoice,//datain.nGrandTotalAmt,
          dDueDate: datain.dDueDate_SSC, //datain.dDueDate,
          sNote: datain.sDocHeader,
          IsStatus: datain.nStatusID,
          IsReqUrgent: datain.IsReqUrgent,
          IsVendorGroup: datain.IsVendorGroup,
          //PaymentDoc: datain.sPaymentDoc,
        })
        num++;
      })
      let FromArray = this.PaymentForm.get('SupDoc') as FormArray;
      FromArray.controls.forEach(function (value, i) {
        if (value.get("cbExport").value == true) {
          value.get("sSupportDoc").enable();
        } else {
          value.get("sSupportDoc").disable();
        }
      })
      FromArray.controls.forEach(function (forms, i) {
        if (forms.get("IsStatus").value == 11 || forms.get("IsStatus").value == 12) {
          if (forms.get("cbExport").value == true) {
            forms.get("nYear").enable();
            forms.get("sSupportDoc").enable();
          } else {
            forms.get("sPaymentDoc").disable();
            forms.get("sSupportDoc").disable();
            forms.get("nYear").disable();
            forms.get("cbSubDoc").disable();
          }

          let nCheckItem = _this.SupDoc.value.filter(w => w.cbExport == true).length;
          var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
          cbExport_All.checked = FromArray.value.length == nCheckItem;
        } else {
          _this.iswait = false;
        }
      })
  }

  cbExport(item, sReq) {
    let _this = this;
    let row = _this.SupDoc.value.map(function (e) { return e.sReqNo; }).indexOf(sReq);
    let FromArray = this.PaymentForm.get('SupDoc') as FormArray;
    let arr = ["sPaymentDoc", "nYear"]
    if (_this.SupDoc.at(row).value.IsStatus == 11) { //|| _this.SupDoc.at(row).value.IsStatus == 12
      arr.forEach(function (val, i) {
        const control = FromArray.at(row).get(val);
        control.disabled == false ? control.disable() : control.enable();
        if (val != "nYear") {
          if (control.disabled == true) {
            control.clearValidators();
            control.markAsUntouched({ onlySelf: true });
            control.setErrors(null);
            control.setValidators(Validators.required);
            control.updateValueAndValidity();
            control.patchValue("");
          }
        } else {
          control.setValidators(Validators.required);
          control.updateValueAndValidity();
        }
      })
    }
    FromArray.at(row).get("cbExport").patchValue(item.target.checked);

    let nCheckItem = _this.SupDoc.value.filter(w => w.cbExport == true).length;
    var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
    cbExport_All.checked = FromArray.value.length == nCheckItem;

    this.CbSaveAll(item, sReq);
  }

  cbExportAll(item) {
    let _this = this;
    let FromArray = this.PaymentForm.get('SupDoc') as FormArray;
    FromArray.controls.forEach(function (arr, i) {
      if (arr.get("IsStatus").value == 11) {
        arr.patchValue({ cbExport: item.target.checked })
        if (item.target.checked) {
          arr.get('nYear').enable();
          arr.get('sPaymentDoc').enable();
          arr.get('sPaymentDoc').setValidators(Validators.required);
          arr.get('sPaymentDoc').updateValueAndValidity();
          _this.CbSaveAll(item, arr.value.sReqNo);
        }
        else {
          arr.patchValue({ cbExport: false })
          arr.get('nYear').disable();
          arr.get('sPaymentDoc').disable();
          arr.setErrors(null);
          arr.markAsUntouched({ onlySelf: true });
          _this.CbSaveAll(item, arr.value.sReqNo);
        }
      } else {
        arr.patchValue({ cbExport: false })
        arr.get('nYear').disable();
        arr.get('sPaymentDoc').disable();
      }
    })
  }

  CbSaveAll(item, sReq) {
    if (item.target.checked == false) {
      let row = this.arrCbExport.filter(m => m.sRequestID == sReq);
      if (row.length > 0) {
        row[0].isChecked = false;
      }
    } else {
      let obj = {
        sRequestID: sReq,
        isChecked: item.target.checked,
      };
      let row = this.arrCbExport.filter(m => m.sRequestID == sReq);
      if (row.length > 0) {
        row[0].isChecked = true;
      }
      else {
        this.arrCbExport.push(obj);
      }
    }
  }

  Export() {
    let _this = this;
    let SaveData = _this.SupDoc.value.filter(f => f.cbExport == true).map(m => ({ sRequestCode: m.sReqNo, nYear: m.nYear, sPaymentDoc: m.sPaymentDoc }))
    let arrRequestID = _this.SupDoc.value.filter(f => f.cbExport == true).map(m =>
      m.sReqNo
    )
    let SaveSumID = function () {
      _this.SumID = arrRequestID.join(",");
    }
    let SaveStatus = function () {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let Dataexport = JSON.stringify(SaveData)
      _this.System.BlockUI();
      _this.http.post(_this.System.SiteName + "api/AdminPayment/Save", Dataexport, { headers, responseType: 'text' }).subscribe(s => {
        _this.System.UnBlockUI();
        if (s == "Success") {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, "Data is already saved.", function () {
            _this.arrCbExport = [];
            _this.Search();
            SaveSumID();
          });
        }
      })
    }
    if (SaveData.length > 0) {
      let IsPass = true;
      for (var i = 0; i < this.SupDoc.length; i++) {
        if (!_this.SupDoc.at(i).get('sPaymentDoc').valid && _this.SupDoc.at(i).get('sPaymentDoc').disabled != true) {
          _this.SupDoc.at(i).get('sPaymentDoc').markAsTouched({ onlySelf: true });
          IsPass = false;
        }
      }
      if (IsPass) {
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, "Do you want to Paid data?", SaveStatus, function () { });
      }
    }
    if (SaveData.length <= 0) {
      this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_Warning, "Please select the information you want to Paid?", function () { });
    }
  }

  async Search() {
    this.OptionGrid.nCurrentPage = 1;
    this.SupDoc.clear();
    this._PaymentForm.SupDoc.reset();
    let _this = this;
    let data: any;
    let ReqType: string = this.FilterGrid.nReqTypeID.length > 0 ? this.FilterGrid.nReqTypeID.map(e => e.sValue).join(",") : "";
    let Status: string = this.FilterGrid.nStatusID.length > 0 ? this.FilterGrid.nStatusID.map(e => e.sValue).join(",") : "";
    let sCompanyCode: string = this.FilterGrid.sCompanyCode.length > 0 ? this.FilterGrid.sCompanyCode.map(e => e.COMPANY_CODE).join(",") : "";
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('sStatus', Status)
        .set('sReqType', ReqType)
        .set('sCompanyCode', sCompanyCode)
    };
    await this.http.get<any>(this.System.SiteName + "api/AdminPayment/Search", httpOptions).toPromise().then(Data => {
      if (Data) {
        data = Data
        this._ArrData = Data,
          this._ArrDataBind = Data
      }
      else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
    this.lstData = data;

    let arrData = [];
    if (this.arrCbExport.length > 0) {
      this.lstData.forEach(function (item) {
        let itemChecked = _this.arrCbExport.filter(m => m.sRequestID == item.sRequestCode);
        if (itemChecked.length > 0) {
          arrData.push(Object.assign({ cbExport: itemChecked[0].isChecked }, item));
        }
        else {
          arrData.push(Object.assign({ cbExport: false }, item));
        }
      });
      let FromArray = this.PaymentForm.get('SupDoc') as FormArray;
      let nCheckItem = _this.SupDoc.value.filter(w => w.cbExport == true).length;
      var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
      cbExport_All.checked = FromArray.value.length == nCheckItem;
    } else {
      arrData = this.lstData;
    }

    //this.SupDoc.clear();
    //this._PaymentForm.SupDoc.reset();
    //let num = 0;
    //if (arrData != null) {
    //  arrData.forEach(function (datain, i) {
    //    _this.SupDoc.push(new FormGroup({
    //      cbExport: new FormControl(''),
    //      nYear: new FormControl(''),
    //      sPaymentDoc: new FormControl('', Validators.required),
    //      sSupportDoc: new FormControl('', Validators.required),
    //      sReqNo: new FormControl(''),
    //      sReqType: new FormControl(''),
    //      sVendor: new FormControl(''),
    //      sCCTR: new FormControl(''),
    //      nTotalAmount: new FormControl(''),
    //      dDueDate: new FormControl(''),
    //      sNote: new FormControl(''),
    //      IsStatus: new FormControl(''),
    //      IsReqUrgent: new FormControl(''),
    //      IsVendorGroup: new FormControl(''),
    //      cbSubDoc: new FormControl('')
    //    }))
    //    _this.SupDoc.at(num).patchValue({
    //      cbExport: datain.cbExport,
    //      nYear: datain.nYear == null ? new Date().getFullYear() : datain.nYear,
    //      sPaymentDoc: datain.sPaymentDoc,
    //      sSupportDoc: datain.sSupportingDocument,
    //      sReqNo: datain.sRequestCode,
    //      sReqType: datain.sReqType,
    //      IsReqType: datain.nReqTypeID,
    //      sVendor: datain.vendor,
    //      sCCTR: datain.sCCTR,
    //      nTotalAmount: datain.nGrandTotalAmt,
    //      dDueDate: datain.dDueDate,
    //      sNote: datain.sDocHeader,
    //      IsStatus: datain.nStatusID,
    //      IsReqUrgent: datain.IsReqUrgent,
    //      IsVendorGroup: datain.IsVendorGroup,
    //    })
    //    num++;
    //  })
    //  let FromArray = this.PaymentForm.get('SupDoc') as FormArray;
    //  FromArray.controls.forEach(function (value, i) {
    //    if (value.get("cbExport").value == true) {
    //      value.get("sSupportDoc").enable();
    //    } else {
    //      value.get("sSupportDoc").disable();
    //    }
    //  })
    //  FromArray.controls.forEach(function (forms, i) {
    //    if (forms.get("IsStatus").value == 11 || forms.get("IsStatus").value == 12) {
    //      if (forms.get("cbExport").value == true) {
    //        forms.get("nYear").enable();
    //        forms.get("sSupportDoc").enable();
    //      } else {
    //        forms.get("sPaymentDoc").disable();
    //        forms.get("sSupportDoc").disable();
    //        forms.get("nYear").disable();
    //        forms.get("cbSubDoc").disable();
    //      }
    //    } else {
    //      _this.iswait = false;
    //    }
    //  })
    //}
    this.System.UnBlockUI();
  }

  async seeCCTR(template: TemplateRef<any>, sRequestCode) {
    let cctrData = { sRequestCode }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminPayment/GetsCCTR", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrGL = JSON.parse(data);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }

  seeNote(Note: TemplateRef<any>, index) {
    this.sSeeNote = this.SupDoc.at(index).get('sNote').value;
    this.modalRef = this.modalService.show(
      Note,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }

  async seeItem(Multi: TemplateRef<any>, sReqNo) {
    let ItemData = { sReqNo }
    let sendData = JSON.stringify(ItemData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let dataMulti: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminPayment/_GetItems", sendData, { headers, responseType: 'text' }).toPromise().then(Data => dataMulti = Data)
      this.arrMulti = JSON.parse(dataMulti);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(Multi, config);
  }

  handler(row) {
    let sdate = this.SupDoc.at(row).value.nYear;
    let stype = typeof sdate;
    let _date = stype == "number" ? new Date(parseInt(sdate), 0) : new Date(this.SupDoc.at(row).value.nYear);
    //let _this = this;
    this.SupDoc.at(row).patchValue({
      //nYear: +this.datepipe.transform(new Date(_this.SupDoc.at(row).value), 'yyyy')
      //nYear: +this.datepipe.transform(new Date(_this.SupDoc.at(row).value.nYear), 'yyyy')
      nYear: _date.getFullYear()
    })
  }

  SetForm() {
    this.PaymentForm = this.formBuilder.group({
      SupDoc: new FormArray([
        new FormGroup({
          cbExport: new FormControl(''),
          nYear: new FormControl(''),
          sPaymentDoc: new FormControl('', Validators.required),
          sSupportDoc: new FormControl('', Validators.required),
          sReqNo: new FormControl(''),
          sReqType: new FormControl(''),
          sVendor: new FormControl(''),
          sCCTR: new FormControl(''),
          nTotalAmount: new FormControl(''),
          dDueDate: new FormControl(''),
          sNote: new FormControl(''),
          IsStatus: new FormControl(''),
          IsReqUrgent: new FormControl(''),
          IsVendorGroup: new FormControl(''),
          cbSubDoc: new FormControl('')
        })
      ]),
      Payment_Doc: new FormControl('', Validators.required),
      Payment_ReqNo: new FormControl('')
    });

  }
  isFieldValidTbExprot(_Field: string, _inx) {
    let FromArray = this.PaymentForm.get('SupDoc') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbExprot(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbExprot(_Field, _inx),
      'has-feedback': this.isFieldValidTbExprot(_Field, _inx)
    };
  }
  isFieldValid(_Field: string) {
    return !this.PaymentForm.get(_Field).valid && this.PaymentForm.get(_Field).touched;
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }


  onClick(value: string) {
    let _this = this;
    if (value == "Back") {
      this.router.navigate(["/admin-menu"]);
    }
  }

  onClear() {
    this.FilterGrid.nReqTypeID = [];
    this.FilterGrid.nStatusID = [];
    this.FilterGrid.sSearch = "";
    this.Search();
  }


  OpenPaymentDoc(templetePaymentDoc: TemplateRef<any>, row, num) {
    this._PaymentForm.Payment_Doc.reset();
    this.Editnum = num;
    let code_ = row.controls["sReqNo"].value
    let sPaymentDoc_ = row.controls["sPaymentDoc"].value
    this.PaymentForm.get("Payment_ReqNo").setValue(code_);
    this.PaymentForm.get("Payment_Doc").setValue(sPaymentDoc_);

    this.modalRef = this.modalService.show(
      templetePaymentDoc,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  UpdatePaymentDoc() {
    let Pass = true;
    let This = this;
    //Field.forEach(function (Item) {
    if (!This.PaymentForm.get("Payment_Doc").valid) {
      This.PaymentForm.get("Payment_Doc").markAsTouched({ onlySelf: true });
      Pass = false;
    }
    ///  });

    if (Pass) {
      //let _this = this;
      this.PaymentForm.controls["Payment_Doc"].setValue(this.PaymentForm.controls["Payment_Doc"].value);

      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, function () {
        This.System.BlockUI();
        let SaveData: any[] = [{
          sRequestCode: This.PaymentForm.controls["Payment_ReqNo"].value,
          sPaymentDoc: This.PaymentForm.controls["Payment_Doc"].value,
          IsExport: false,
        }];
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let Data = JSON.stringify(SaveData)
        This.System.BlockUI();
        This.http.post(This.System.SiteName + "api/AdminPayment/Save", Data, { headers, responseType: 'text' }).subscribe(s => {
          This.System.UnBlockUI();
          if (s == "Success") {
            This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, "Data is already saved.", function () {
              This.arrCbExport = [];
              This.Search();
            });
            This.modalRef.hide();
          }
        })
      }, function () {
        Swal.close();
        //this.Editnum = null;
        this.PaymentForm.Payment_Doc.reset();
        this.modalRef.hide();
      });

    } else {

    }
  }
  ExportExcel() {
    const PaymentExportExcelBody = [];
    const prepareBody = [];
    let mergeData = {};
    let dataList = {};
    for (let x = 0; x < this._ArrData.length; x++) {
      dataList = this._ArrData[x];
      prepareBody.push(dataList);
    }
    for (const _item of prepareBody) {
      PaymentExportExcelBody.push(_item);
    }
    mergeData = {
      PaymentExportExcelBody
    };
    const prepareToRequest = [];
    prepareToRequest.push(mergeData);
    const Data = JSON.stringify(prepareToRequest);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    this.http.post(this.System.SiteName + 'api/AdminPayment/PaymentExportExcel', Data, {
      headers,
      responseType: 'arraybuffer'
    }).subscribe(res => {
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      this.save(blob, 'Payment.xlsx');
    });
  }
  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) { // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else { // For other browsers:
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }
}

